import { GridColDef } from '@mui/x-data-grid';
import { DURATION_SECONDS } from '../../../constants';
import { Week } from '../../../services/date/types';

export interface BurstSlice {
  columns: GridColDef[];
  [DURATION_SECONDS.FIVE]: Burst;
  [DURATION_SECONDS.TEN]: Burst;
  [DURATION_SECONDS.FIFTEEN]: Burst;
  [DURATION_SECONDS.THIRTY]: Burst;
  [DURATION_SECONDS.FORTY_FIVE]: Burst;
  [DURATION_SECONDS.SIXTY]: Burst;
  [DURATION_SECONDS.NINETY]: Burst;
}

export interface Burst {
  budget: number;
  calculatedTotalBudget: number;
  calculatedTotalTarps: number;
  calculatedTotalImpact: number;
  tarps: number;
  impact: number;
  rows: rowStructure[];
}

export interface ColumnStructure {
  field: string;
  headerName: string;
  headerAlign: ALIGNMENT;
  align: ALIGNMENT;
  type?: any;
  renderCell?: any;
  sortable: boolean;
  editable: boolean;
}

export interface rowStructure {
  id: number;
  active: boolean;
  split: any;
  weekCommencing: string;
  cpt: number;
  cpm: number;
  tarps: number;
  budget: number;
  impact: number;
  weekMetaData: Week;
}

export enum EDITABLE_COLUMN {
  BUDGET = 'budget',
  TARPS = 'tarps',
  IMPACT = 'impact'
}

export enum ALIGNMENT {
  RIGHT = 'right',
  CENTER = 'center',
  LEFT = 'left'
}

export enum TYPE {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean'
}
